// write ContextApi

import React from 'react';
export const LoaderContext = React.createContext();
export const ToasterContext = React.createContext();

export const ReferenceContext = React.createContext();

export const WorkFlowContext = React.createContext();
export const MatrixContext = React.createContext();